import {action, Action} from 'easy-peasy';
import {simpleCrudStoreFactory, SimpleCrudStoreModel} from '@/utils/storeFactories';

interface UserConfigure {
    id: number;
    username: string;
    email: string;
}

interface Notification {
    id: number;
    title: string;
    schedule: string;
    storyboardId: number;
    active: boolean;
    usersConfigured: UserConfigure[];
}

export interface MyNotificationsStoreModel extends SimpleCrudStoreModel<Notification> {
    addOrEditNotification: Action<MyNotificationsStoreModel, Notification>;
    editNotificationConfigure: Action<MyNotificationsStoreModel, [number, UserConfigure[]]>;
    deleteOne: Action<MyNotificationsStoreModel, number>;
    deleteNotificationConfigure: Action<MyNotificationsStoreModel, [number, number]>;
}

export default {
    ...simpleCrudStoreFactory(),
    addOrEditNotification: action((state, notification) => {
        const existingIndex = state.items.findIndex((n) => n.id === notification.id);

        if (existingIndex !== -1) {
            state.items.splice(existingIndex, 1);
        }

        state.items.pop();
        state.items.unshift(notification);
    }),
    editNotificationConfigure: action((state, [notificationId, notificationConfigures]) => {
        const existingIndex = state.items.findIndex((n) => n.id === notificationId);

        state.items[existingIndex].usersConfigured = notificationConfigures;
    }),
    deleteOne: action((state, notificationId) => {
        const index = state.items.findIndex((n) => n.id === notificationId);

        state.items.splice(index, 1);
    }),
    deleteNotificationConfigure: action((state, [notificationId, userId]) => {
        const index = state.items.findIndex((n) => n.id === notificationId);

        const existingIndex = state.items[index].usersConfigured.findIndex((n) => n.id === userId);

        state.items[index].usersConfigured.splice(existingIndex, 1);
    }),
} as MyNotificationsStoreModel; 